import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useBrands = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isBrandActive = (brand) => {
    if (typeof brand?.active === 'boolean') return brand.active;
    if (typeof brand?.is_active === 'boolean') return brand.is_active;
    if (brand?.active === 1 || brand?.active === '1' || brand?.active === 'true') return true;
    if (brand?.is_active === 1 || brand?.is_active === '1' || brand?.is_active === 'true') return true;
    return false;
  };

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setLoading(true);
        console.log('Fetching brands from Supabase...');

        // Fetch brands then filter active client-side to support legacy/new schemas
        const { data, error: fetchError } = await supabase
          .from('brands')
          .select('*')
          .order('name', { ascending: true });
        
        console.log('Brands response - data:', data, 'error:', fetchError);

        if (fetchError) {
          console.error('Error fetching brands:', fetchError);
          throw fetchError;
        }

        if (data) {
          // Ensure only active brands are shown on customer pages
          const activeBrands = data.filter(isBrandActive);
          console.log(`Found ${activeBrands.length} active brands out of ${data.length} total:`, activeBrands);
          setBrands(activeBrands);
        } else {
          console.log('No brands found');
          setBrands([]);
        }
      } catch (err) {
        console.error('Error fetching brands:', err);
        setError(err.message);
        setBrands([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  return { brands, loading, error };
};
